$(document).ready(function() {
    if ($("body.HomePage .banner-images")) {
        var target = $("body.HomePage .banner-images");

        $(target).find("img:first-child").fadeIn();

        var rotateTimer = setInterval(function() {
            var next = $(target).find("img:visible + img");

            if (! next.length) {
                next = $(target).find("img:first-child");
            }

            $(target).find("img:visible").fadeOut(1000);
            $(next).fadeIn(1000);
        }, 5000);
    }
});


// WEBPACK FOOTER //
// ./site/js/components/homepage-banner-rotate.js